import { ReadonlyRepositoryListService, Result } from '@softline/core';
import { computed, inject, Injectable, INJECTOR } from '@angular/core';
import { SupplierIdService } from './supplier-id.service';
import { SupplierContact } from '../types/supplier-contact';
import { LieferantenKontakteRepository } from '../repositories/lieferanten-kontakte.repository';
import { LieferantenQuery } from '../types/lieferanten-query';
import { handleRequestError } from '@softline/application';
import { MessageBarService } from '@softline/ui-core';

@Injectable()
export class LieferantenKontakteService extends ReadonlyRepositoryListService<
  SupplierContact,
  Result<SupplierContact[]>,
  LieferantenQuery
> {
  readonly #injector = inject(INJECTOR);
  readonly #messageBarService = inject(MessageBarService);
  readonly #supplierIdService = inject(SupplierIdService);
  readonly #contactRepo = inject(LieferantenKontakteRepository);

  supplierId = computed(() => this.#supplierIdService.supplierId()());
  override params = computed(() => {
    return { id: this.supplierId() };
  });

  constructor() {
    super(inject(LieferantenKontakteRepository));
  }

  protected override getItems(
    result: Result<SupplierContact[]> | null | undefined
  ): SupplierContact[] {
    return result as any;
  }

  async changeContact(
    contactKey: string,
    supplierId: number,
    patchBody: Partial<SupplierContact>
  ) {
    try {
      const response = await this.#contactRepo.changeContact(
        contactKey,
        supplierId,
        patchBody
      );

      const items = [...this.value()];
      const index = items.findIndex((o) => o.key === contactKey);

      if (index < 0) {
        return;
      }

      items[index] = response;
      this.all.set(items);
      this.#messageBarService.success('Kontakt wurde Erfolgreich bearbeitet.');
    } catch (error) {
      handleRequestError(error, this.#injector, { show: true });
    }
  }
}
